import { Inject } from "@angular/core";
import { IbaseClass } from "./ibase-class";
import { IbaseService } from "../base-service/ibase-service";
import { environment } from "src/environments/environment";
import { api } from "../services/api";
import { Subscription } from "rxjs";
import { Events, EventsName } from "../model/event";


export abstract class BaseClass<T> implements IbaseClass<any> {
  abstract getServices(): IbaseService<T>;
  protected subs: Subscription[] = [];

  public env = environment;
  public api = api;

  public isLoad = false;
  public userData = this.getLocalItem('user');
  public webSocketUrl: string = '';

  public events = {
    sports: Events.Sports.split(",").map((e) => { return Number(e) }),
    races: Events.Races.split(",").map((e) => { return Number(e) }),
    casino: Events.Casino.split(",").map((e) => { return Number(e) }),
    casino1: Events.Casino1.split(",").map((e) => { return Number(e) }),
    iCasino: Events.ICasino.split(",").map((e) => { return Number(e) }),
  }

  constructor() {
  }

  getLocalItem(key: string, isParse: boolean = true) {
    return (isParse) ? JSON.parse(localStorage.getItem(`${this.env.panel + key}`) as any) : localStorage.getItem(`${this.env.panel + key}`) as any;
  }

  setLocalItem(key: string, data: any) {
    localStorage.setItem(`${this.env.panel + key}`, JSON.stringify(data));
  }

  isLogin() {
    return (localStorage.getItem(`${this.env.panel}id_token`)) ? true : false;
  }

  kFormatter(num: any) {
    if (num) {
      const n = (Math.abs(num) / 1000).toFixed(1);
      return Math.abs(num) > 999
        ? Math.sign(num) * parseFloat(n) + 'k'
        : Math.sign(num) * Math.abs(num);
    } else {
      return '-';
    }
  }

  positiveVal(e: any) {
    return e ? Number(Math.abs(e)) : e;
  }

  subtractMinutes(numOfMinutes: number, date = new Date()) {
    date.setMinutes(date.getMinutes() - numOfMinutes);
    return date;
  }

  roundVal(e: any) {
    return e ? ~~e : e
  }

  fixedPostDecimal(e: any, num: number = 2) {
    return e ? parseFloat(e).toFixed(num) : e
  }

  gotoDiv(location: any) {
    let el = document.getElementById(location) as HTMLElement;
    if (el)
      el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
  }

  genMarketReq(res: any) {
    let market: any[] = [];
    res.forEach((element: any) => {
      market.push('market_ids[]=' + encodeURIComponent(element.market_id));
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];

    return market.join('&') as any;
  }

  groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K) {
    const map = new Map();
    list.forEach((item: any) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  genListBanner() {
    let banners: any[] = [];
    if (this.env.host.isCustomBanner) {
      let ts = (Date.now() - Date.now() % 300) + '000';
      // banners = [
      //   `https://ndexch.com/images/all/1.jpg?updatedAt=${ts}`,
      //   `https://ndexch.com/images/all/2.jpg?updatedAt=${ts}`,
      //   `https://ndexch.com/images/all/3.jpg?updatedAt=${ts}`,
      //   `https://ndexch.com/images/all/4.jpg?updatedAt=${ts}`,
      //   `https://ndexch.com/images/all/5.jpg?updatedAt=${ts}`]
        banners = [
          `https://static-content-banners.s3.ap-south-1.amazonaws.com/kanha/banner1.jpg?updatedAt=${ts}`,
          `https://static-content-banners.s3.ap-south-1.amazonaws.com/kanha/banner2.jpg?updatedAt=${ts}`,
          `https://static-content-banners.s3.ap-south-1.amazonaws.com/kanha/banner3.jpg?updatedAt=${ts}`,
          `https://static-content-banners.s3.ap-south-1.amazonaws.com/kanha/banner4.jpg?updatedAt=${ts}`,
          `https://static-content-banners.s3.ap-south-1.amazonaws.com/kanha/banner5.jpg?updatedAt=${ts}`,
          // `https://ndexch.com/images/all/5.jpg?updatedAt=${ts}`
        ]
    } else {
      banners = [
        'https://speedcdn.io/assets/king-v8/bnr1.jpg',
        'https://speedcdn.io/assets/king-v8/bnr2.jpg',
        'https://speedcdn.io/assets/king-v8/bnr3.jpg',
        'https://speedcdn.io/assets/king-v8/bnr4.jpg',
        'https://speedcdn.io/assets/king-v8/bnr5.jpg']
    }
    return banners;
  }

}
